import env from "@irati/utils/env"
import {PRODUCTION} from "@irati/utils/constants/environment"

const isProduction = env.ENVIRONMENT_NAME === PRODUCTION

export const MAPS_API_KEY = isProduction ? "AIzaSyCPXF8Q1j-RgN12_X_4p9yu2bP1xwBYXDo" : "AIzaSyCTNilT7fCfakHs5WxNwEmtGVzqmhIgN6E"
